import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import Modal from 'components/Modal';
import Button from 'components/Button';
import TextField from 'components/TextField';
import { actions as toastrActions } from 'react-redux-toastr';
import { Container, WrapperButtons, WrapperInput, InputRow } from './styles';

function ModalEmitirCteLote({ open, onClose, onConfirm }) {
  const dispatch = useDispatch();
  const [idDe, setIdDe] = useState('');
  const [idAte, setIdAte] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!idDe || !idAte) {
      dispatch(
        toastrActions.add({
          type: 'error',
          title: 'Erro',
          message: 'Por favor, preencha os campos De e Até',
        })
      );
      return;
    }

    const de = parseInt(idDe, 10);
    const ate = parseInt(idAte, 10);

    if (isNaN(de) || isNaN(ate)) {
      dispatch(
        toastrActions.add({
          type: 'error',
          title: 'Erro',
          message: 'Os valores devem ser números válidos',
        })
      );
      return;
    }

    if (de > ate) {
      dispatch(
        toastrActions.add({
          type: 'error',
          title: 'Erro',
          message: 'O valor "De" deve ser menor ou igual ao valor "Até"',
        })
      );
      return;
    }

    setLoading(true);
    try {
      if (onConfirm) {
        await onConfirm(de, ate);
      }
      handleClose();
    } catch (error) {
      dispatch(
        toastrActions.add({
          type: 'error',
          title: 'Erro',
          message: error.message || 'Erro ao processar emissão',
        })
      );
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setIdDe('');
    setIdAte('');
    onClose();
  };

  return (
    <Modal open={open} onClose={handleClose} title="Emitir CT-e em Lote">
      <Container>
        <InputRow>
          <WrapperInput>
            <TextField
              label="De (ID)"
              name="idDe"
              type="number"
              value={idDe}
              onChange={(e) => setIdDe(e.target.value)}
              fullWidth
              placeholder="ID inicial"
            />
          </WrapperInput>
          <WrapperInput>
            <TextField
              label="Até (ID)"
              name="idAte"
              type="number"
              value={idAte}
              onChange={(e) => setIdAte(e.target.value)}
              fullWidth
              placeholder="ID final"
            />
          </WrapperInput>
        </InputRow>

        <WrapperButtons>
          <Button
            label="Cancelar"
            onClick={handleClose}
            color="secondary"
            margin="0 10px 0 0"
            disabled={loading}
          />
          <Button
            label={loading ? 'Processando...' : 'Emitir'}
            onClick={handleSubmit}
            color="primary"
            disabled={loading || !idDe || !idAte}
          />
        </WrapperButtons>
      </Container>
    </Modal>
  );
}

export default ModalEmitirCteLote;

